import styled from "styled-components";
import LikeList from "./LikeList";

const StyledLikeList = styled(LikeList)`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`;

export default StyledLikeList;
